import { Box, Text } from '@nimbus-ds/components';
import { useTranslationLanguage } from 'commons/hooks';
import type { ChatMessageProps } from './types';

/**
 * UserMessage component renders user messages inside the chat
 */
function ChatUserMessage({ message }: ChatMessageProps): JSX.Element {
  const locale = useTranslationLanguage();

  const formattedTime = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
  }).format(message.timestamp);

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end" gap="2">
      <Box
        maxWidth="85%"
        backgroundColor="primary-surface"
        borderRadius="4"
        px="4"
        py="2-5"
      >
        <Text fontSize="base" color="neutral-textHigh" lineHeight="base">
          {message.content}
        </Text>
      </Box>

      <Text fontSize="caption" color="neutral-textLow">
        {formattedTime}
      </Text>
    </Box>
  );
}

export default ChatUserMessage;
